import React from 'react'
import LineProgress from '../../../shared/LineProgress'

const DisbursementsProjectionsYearCard = ({ t, mp }) => {
    return (
        <div className="disbursement">
            <h3 className="chart-title">{t('one_pager_report.year_disbursements')}</h3>
            <div className="chart-content">
                <LineProgress
                    totalDisbursed={mp.fields.projectionsDisbursementsYearPercent}
                    totalDisbursedPercent={mp.fields.projectionsDisbursementsYearPercent}
                    totalPending={mp.fields.projectionsDisbursementsYearPercent}
                    totalPendingPercent={mp.fields.projectionsDisbursementsYearPercent}
                    format='USD'
                />
            </div>
        </div>
    )
}

export default DisbursementsProjectionsYearCard